import { useQuery } from '@tanstack/react-query';

import useBlobFile, { RequestToFileResponseProps } from 'hooks/useBlobFile';
import { useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryModeloImportacao() {
    const { requestToFile } = useBlobFile();
    const requestListagem = useRequestListagem();

    return useQuery<RequestToFileResponseProps>(
        ['queryModeloImportacao'],
        () =>
            requestListagem({
                url: '/gestao/lojaconfiguracaoimportacao/template',
            }).then((res) => res),
        {
            enabled: false,
            onSuccess: (data) => {
                requestToFile(data, true);
            },
        },
    );
}
